import { useRouter } from "next/router";
import Head from "next/head";
import "../styles/globals.css";
import StorefrontProvider from "../providers/storefront";

const MyApp = (props) => {
  const { Component, pageProps } = props;
  const { global, preview } = pageProps || {};

  const router = useRouter();
  const canonicalUrl = `https://www.aftershockpc.com.au${
    router.asPath === "/" ? "" : router.asPath
  }`.split("?")[0];

  return (
    <StorefrontProvider globalProps={global}>
      <Head>
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <Component {...pageProps} global={global} />
    </StorefrontProvider>
  );
};

export default MyApp;
